var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLightRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 29,
    x: 1,
    y: 1,
    fill: "#E16F6F",
    stroke: "#fff",
    strokeWidth: 2,
    rx: 14.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.233 8.365l5.517 5.429 5.517-5.429L24 10.071 18.483 15.5 24 20.929l-1.733 1.706-5.517-5.43-5.517 5.43L9.5 20.929l5.517-5.43L9.5 10.072l1.733-1.706z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLightRed);
export default ForwardRef;